<template>

  <div class="card-content" style="padding: 5px 15px;">


<!--     <b-select placeholder="Select a name">
        <option
            v-for="option in data"
            :value="option.id"
            :key="option.id">
            {{ option.user.first_name }}
        </option>
    </b-select> -->

    <div style="display:flex; margin-bottom:10px;">

        <button class="button" style="width:123px; margin-right:3px;">MANAGED BY</button>

        <b-autocomplete
            v-model="manageBy"
            placeholder="Search Manager"
            :data="organizations"
            field="name"
            @select="option => updateManager(option)"
            style="width:100%;">
        </b-autocomplete>
            
    </div>
    

    <div style="display:flex;">
        
        <b-button style="margin-right:3px;" 

        @click.prevent="createUser = true" v-if="(!createUser && !selected) && (!isSuperadmin || create)">CREATE</b-button>

        <b-button style="margin-right:3px;" 

        @click.prevent="archived_at = !archived_at" v-if="!createUser && !selected" :label="archived_at ? 'HIDE INACTIVE' : 'SHOW INACTIVE'"></b-button>

        <input type="text" ref="searchUser" class="input" placeholder="Search" v-model="keyword" @keyup.enter="searchTeleport" v-if="!createUser && !selected">

    </div>



<!--     <b-button type="is-link" style="float:right;" @click="apply" :disabled="selectedRole == 'Select Role' || !enableApply " 

    v-if="(!createUser && canManageUser && !selected) && !isSuperadmin">Apply</b-button>
  
    <b-dropdown aria-role="list" style="float:right;" v-if="(!createUser && canManageUser && !selected) && !isSuperadmin">

      <button class="button" type="button" slot="trigger" style="min-width:95px; margin-right:4px;">
          
          {{ selectedRole }} 

          <i class="fa fa-chevron-down" style="margin-left:5px;"></i>
      
      </button>

      <b-dropdown-item @click="selectedRole = role.toUpperCase()" v-for="(role, key) in roles" :key="key"> {{ role.toUpperCase() }} </b-dropdown-item>

    </b-dropdown> -->

    <user-table
      :organization-id="organization.id"
      :archived-at="archived_at"
      :selected.sync="selected"
      :height="height"
      :keyword.sync="keyword"
      :create.sync="create"
      :enableApply.sync="enableApply"
      ref="userTable"
      v-if="!createUser && !selected"
      style="margin-top:15px;"
    ></user-table>

    <user-form
      v-else
      :organization-id="organization.id"
      :user="selected"
      :height="height"
      @create-success="onCreateSuccess"
      @update-success="onUpdateSuccess"
      @archive-success="onArchiveSuccess"
      @restore-success="onRestoreSuccess"
      @remove-success="onRemoveSuccess"
      @close="selected = null, createUser = false"
    ></user-form>
  </div>
</template>

<script>
import UserTable from "./userTable";
import UserForm from "./userForm";

import { RoleService } from "@/services/role.service";


import { FirmService } from "@/services/firm.service";

import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  props: {
    organization: {
    },
    height: {
      type: Number,
      default: 500
    },

    organizations: {}
  },
  components: {
    UserTable,
    UserForm
  },
  data: () => ({

    selected: null,
    
    createUser: false,
    
    archived_at: false,
    
    selectedRole: 'Select Role',

    roleService: RoleService,

    roles: [],

    enableApply: false,

    keyword: '',

    create: false,

    manageBy: '',

  }),
  watch: {
    organization() {
      this.$refs.searchUser.focus();
      this.defaultManager();
      this.selected = null;
      this.createUser = false;
      this.$nextTick(() => {
        this.$refs.userTable.fetch();
      });
    },
  },
  methods: {
    fetchUserTableData() {
      this.createUser = false;
      return this.$refs.userTable.fetch();
    },
    onCreateSuccess() {
      this.fetchUserTableData();
    },
    onUpdateSuccess(user) {
      this.selected = user;
      // this.fetchUserTableData();
    },
    onArchiveSuccess(user) {
      this.selected = user;
      // this.fetchUserTableData();
    },
    onRestoreSuccess(user) {
      this.selected = user;
      // this.fetchUserTableData();
    },
    async onRemoveSuccess() {
      await this.fetchUserTableData();
      this.selected = null;
    },

    async apply() {

        await this.$refs.userTable.updateRole(this.selectedRole);

    },

    async fetchRoles() {

        await this.roleService.all().then(response => {

            return this.roles = response.data.map(role => role.attributes.name)

        });

    },

    searchTeleport() {

      this.$refs.userTable.searchTeleport();

    },

    async updateManager(managedBy) {

        if (managedBy) {
            
            const updatedOrganization = await FirmService.updatePartial(this.organization.id, { managed_by: managedBy.id, includes: "managedBy" })
            
            .then(response => JsonDenormalizer.denormalize(response));

            this.$buefy.toast.open({
                message: "Managed by has been updated.",
                type: "is-info",
                position: "is-top-right"
            });

            this.$parent.fetchOrganizationTableData();

        }

    },

    defaultManager() {

        this.manageBy = this.organization.managedBy ? this.organization.managedBy.name : '';

    },


  },

  computed: {

    canManageUser() {

        return this.$store.getters["Auth/hasPermission"]("can manage users");

    },

    isSuperadmin() {
        
        return this.$store.getters["Auth/hasRole"]("superadmin")
    
    }

  },

  mounted() {
    this.fetchRoles();
    this.defaultManager();
    this.$refs.searchUser.focus();
  }


};
</script>

<style scoped>
  
  .search-input {
      min-width: 300px;
      border-radius: 3px;
      border: 1px solid #888888;
      padding: 4px;
      margin-top: 1px;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/Users/list-new/partials/user.vue